import React, { FC } from "react";
import { StyledLoading } from "./style";
import logo from "../../../assets/images/logo/logo.png";
import { Image } from "../../UI/Image";
import { CircularProgress, Typography } from "@mui/material";
import { Button } from "../../UI/Button";

const Loading: FC = ({}) => {
  return (
    <StyledLoading>
      <CircularProgress />
    </StyledLoading>
  );
};

export default Loading;
